import { useCallback, useRef } from 'react';

export type DebounceFunction = (...args: any[]) => void;

export const useDebounceFn = (func: DebounceFunction, delay: number): DebounceFunction => {
  const timerRef = useRef<NodeJS.Timeout | undefined>(undefined);

  return useCallback((...args: any[]) => {
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      func.apply(null, args);
    }, delay);
  }, [func, delay]);
};
